module.exports = __webpack_public_path__ + "static/media/frame_07.a208b2fd.jpg";